import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, postApproval } from "./clientAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
};

export const fetchAll = createAsyncThunk("client/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "client/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response;
  }
);

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = clientSlice.actions;

export const selectData = (state) => state.client.data;
export const selectLoading = (state) => state.client.loading;
export const selectError = (state) => state.client.error;
export const selectPageNo = (state) => state.client.pageNo;
export const selectPageSize = (state) => state.client.pageSize;
export const selectTotalRecord = (state) => state.client.totalRecord;
export const selectSelected = (state) => state.client.selected;
export const selectApproval = (state) => state.client.approval;

export default clientSlice.reducer;
